const teamAndOpp = [
	"drives",
	"totStartYds",
	"timePos",
	"pts",

	// Keep these in sync with player/stats.ts!
	"fmb",
	"fmbLost",
	"pssCmp",
	"pss",
	"pssYds",
	"pssTD",
	"pssInt",
	"pssLng",
	"pssSk",
	"pssSkYds",
	"rus",
	"rusYds",
	"rusTD",
	"rusLng",
	"tgt",
	"rec",
	"recYds",
	"recTD",
	"recLng",
	"pr",
	"prYds",
	"prTD",
	"prLng",
	"kr",
	"krYds",
	"krTD",
	"krLng",
	"defInt",
	"defIntYds",
	"defIntTD",
	"defIntLng",
	"defPssDef",
	"defFmbFrc",
	"defFmbRec",
	"defFmbYds",
	"defFmbTD",
	"defFmbLng",
	"defSk",
	"defTckSolo",
	"defTckAst",
	"defTckLoss",
	"defSft",
	"fg0",
	"fga0",
	"fg20",
	"fga20",
	"fg30",
	"fga30",
	"fg40",
	"fga40",
	"fg50",
	"fga50",
	"fgLng",
	"xp",
	"xpa",
	"tp",
	"tpa",
	"pnt",
	"pntYds",
	"pntLng",
	"pntTB",
	"pntIn20",
	"pntBlk",
	"pen",
	"penYds",

	// KEEP THIS IN SYCN WITH ABOVE! TypeScript needs them to be listed explicitly. Used to be:
	// ...teamAndOpp.map(stat => `opp${helpers.upperCaseFirstLetter(stat)}`),
	"oppDrives",
	"oppTotStartYds",
	"oppTimePos",
	"oppPts",
	"oppFmb",
	"oppFmbLost",
	"oppPssCmp",
	"oppPss",
	"oppPssYds",
	"oppPssTD",
	"oppPssInt",
	"oppPssLng",
	"oppPssSk",
	"oppPssSkYds",
	"oppRus",
	"oppRusYds",
	"oppRusTD",
	"oppRusLng",
	"oppTgt",
	"oppRec",
	"oppRecYds",
	"oppRecTD",
	"oppRecLng",
	"oppPr",
	"oppPrYds",
	"oppPrTD",
	"oppPrLng",
	"oppKr",
	"oppKrYds",
	"oppKrTD",
	"oppKrLng",
	"oppDefInt",
	"oppDefIntYds",
	"oppDefIntTD",
	"oppDefIntLng",
	"oppDefPssDef",
	"oppDefFmbFrc",
	"oppDefFmbRec",
	"oppDefFmbYds",
	"oppDefFmbTD",
	"oppDefFmbLng",
	"oppDefSk",
	"oppDefTckSolo",
	"oppDefTckAst",
	"oppDefTckLoss",
	"oppDefSft",
	"oppFg0",
	"oppFga0",
	"oppFg20",
	"oppFga20",
	"oppFg30",
	"oppFga30",
	"oppFg40",
	"oppFga40",
	"oppFg50",
	"oppFga50",
	"oppFgLng",
	"oppXp",
	"oppXpa",
	"oppTp",
	"oppTpa",
	"oppPnt",
	"oppPntYds",
	"oppPntLng",
	"oppPntTB",
	"oppPntIn20",
	"oppPntBlk",
	"oppPen",
	"oppPenYds",
] as const;

// raw: recorded directly in game sim
// derived: still stored in database, but not directly recorded in game sim
// not present in this file: transiently derived things, like FG%
const stats = {
	derived: [],
	raw: ["gp", "min", ...teamAndOpp] as const,
};

export default stats;
